import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { environment } from "../../environments/environment.development";

/**
 * Custom validator that ensures at least one of agreement or chargeToId is selected
 * When company is internal, agreement is not required (it's disabled)
 * @returns ValidatorFn that returns null if valid, error object if invalid
 */
export function atLeastOneChargeTargetValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormGroup)) {
      return null;
    }

    const company = control.get('company')?.value;
    const chargeToId = control.get('chargeToId')?.value;
    const agreement = control.get('agreement')?.value;

    // If company is internal, agreement is disabled, so only chargeToId matters
    if (company && company.id === environment.internalCompanyId) {
      return chargeToId ? null : { atLeastOneChargeTarget: { message: 'Charge code is required for internal company' } };
    }

    // For non-internal companies (or null company), require either chargeToId OR agreement
    const hasChargeTarget = !!chargeToId || !!agreement;
    return hasChargeTarget ? null : { atLeastOneChargeTarget: { message: 'Either charge code or agreement is required' } };
  };
}